{
  "title": "Deposit Information",
  "subtitle": "It's possible to deposit funds to your wallet using the following FIAT deposit address",
  "fetching": "Creating deposit information...",
  "success": "Beneficiary created successfully.",
  "error": "An error occurred while creating the beneficiary. Please try again later.",
  "sending": "Creating beneficiary...",
  "creatingdeposit": "Creating deposit instructions...",
  "copytoclipboard": "Copy to clipboard",
  "button": {
    "sendusingizzi": "SEND WITH IZZI"
  },
  "input": {
    "currency": "Select the token you want to deposit"
  },
  "deposit": {
    "currency": "Currency",
    "bankName": "Bank Name",
    "bankAddress": "Bank Address",
    "bankRoutingNumber": "Bank Routing Number",
    "bankAccountNumber": "Bank Account Number",
    "bankBeneficiaryName": "Owner Name",
    "bankBeneficiaryAddress": "Owner Address",
    "paymentRails": "Rails"
  }
}
